<template>
    <button v-if="type === 'download'">
        <a :href="link" :download="filename">
            {{ text }}
            <i class="ico_download"></i>
        </a>
    </button>
    <button v-else @click="handleClick">
        {{ text }}
        <i v-if="type === 'inbound'" class="ico_inbound"></i>
        <i v-if="type === 'outbound'" class="ico_outbound"></i>
    </button>
</template>
<script>
export default {
    props: {
        text: {},
        to: {},
        type: {},
        link: {},
        href: {},
        filename: {}
    },
    methods: {
        handleClick() {
            if (this.to) {
                this.$router.push(this.to);
            }
            if (this.href) {
                window.open(this.href, '_blank');
            }
        },
    },
};
</script>
<style lang="scss" scoped>
button {
    border: 2px solid var(--red);
    color: var(--red);
    background-color: transparent;
    border-radius: 25px;
    height: 50px;
    padding: 0 33px;
    font-family: 'Pretendard', sans-serif;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;

    &:disabled {
        filter: grayscale(1);
        opacity: 0.5;
    }

    @media screen and (max-width: 768px) {
        padding: 0 15px;
        font-size: 16px;
        height: 42px;
    }

    a {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        color: inherit;
    }

    i {
        display: inline-block;
        width: 24px;
        height: 24px;
        background-position: center;
        background-size: auto;
        background-repeat: no-repeat;

        &.ico_inbound {
            background-image: url(@/assets/ic_inbound.png);
        }

        &.ico_outbound {
            background-image: url(@/assets/ic_outbound.png);
        }

        &.ico_download {
            background-image: url(@/assets/ic_download.png);
        }
    }

    &:hover {
        background: var(--red);
        color: #fff;

        i.ico_inbound {
            background-image: url(@/assets/ic_inbound-w.png);
        }

        i.ico_outbound {
            background-image: url(@/assets/ic_outbound-w.png);
        }

        i.ico_download {
            background-image: url(@/assets/ic_download-w.png);
        }
    }
}
</style>
